// extracted by mini-css-extract-plugin
module.exports = {"RV-G":"NA_RV-G__hrxtC"};